import { Component } from 'react';
import $ from 'jquery';

export class BaseComponent extends Component {
  constructor(props) {
    super(props);

    this.logout = this.logout.bind(this);
    this.checkLoginStatus = this.checkLoginStatus.bind(this);
  }

  logout() {
    document.cookie = 'unithings_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'unithings_user=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    setTimeout(function(){
      window.location.href = '/';
    }, 500);
  }

  getTime() {
    let d = new Date();
    return d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
  }

  // IL TOKEN DEVE ESSERE PASSATO COME props DAL Component PARENT
  checkLoginStatus() {
    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/login',
      headers: {
        'x-session': this.props.token,
      },
      xhrFields: {
        withCredentials: true
      },
      data: JSON.stringify({
        Action: 'GetStatus',
      }),
      dataType: 'JSON',
      success: (res, status, jqXHR) => {
        if (!res.LoggedIn) {
          this.logout();
        }
      },
      error: (httpReq, status, exception) => {
      },
    });
  }

  readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  timestampToDate(timestamp) {
    let date = new Date(timestamp*1000);
    let hours = date.getHours();
    let minutes = '0' + date.getMinutes();
    let seconds = '0' + date.getSeconds();
    let day = date.getDate();
    let monthIndex = date.getMonth() + 1;
    let year = date.getFullYear();

    let formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);

    return day + '/' + monthIndex + '/' + year + ' ' + formattedTime;
  }

}



// WEBPACK FOOTER //
// ./src/components/BaseComponent.js